import React, { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { usePublishQuery, useRemovePublication } from './use-publish-query.js';

export function usePublish({ itineraryGuid, itineraryId }) {
    const [guid, setGuid] = useState(itineraryGuid);
    const isGuidExist = guid ? !!guid : !!itineraryGuid;
    const [isPublished, setIsPublished] = useState(isGuidExist);
    const [isLoadingPublish, setIsLoadingPublish] = useState(false);
    const [publishedLink, setPublishedLink] = useState(`${MEDIA_URL}/itineraries/${guid ?? itineraryGuid}/index.html`);

    useEffect(() => {
        setIsPublished(isGuidExist);
    }, [isGuidExist]);

    useEffect(() => {
        setPublishedLink(`${MEDIA_URL}/itineraries/${guid ?? itineraryGuid}/index.html`)
    }, [guid, itineraryGuid]);

    // PUBLISH
    const publish = usePublishQuery({
        mutationKey: ['itinerary', itineraryId],
        onSuccess: (res) => {
            if (!res.ok) {
                setIsLoadingPublish(false);
                toast.error(res.errorText);
            }
        },
        onError: () => {
            setIsLoadingPublish(false);
            toast.error('Server Error');
        }
    });

    const onPublish = useCallback(() => {
        publish.mutate(itineraryId);
        setIsLoadingPublish(true);
    }, [itineraryId, publish]);

    // UNPUBLISH
    const unpublish = useRemovePublication({
        mutationKey: ['unpublish'],
        onSuccess: (res) => {
            if (res.ok) {
                setIsPublished(false);
                toast.success(_t.crud.itinerary.unpublishSuccess());
            } else toast.error(res.errorText);
        },
        onError: () => toast.error('Server Error')
    });

    const onUnPublish = useCallback(() => {
        if (confirm(_t.crud.itinerary.unpublishAlert())) {
            unpublish.mutate(itineraryId);
        }
    }, [itineraryId, unpublish, setIsPublished]);

    const onUpdateGuid = useCallback(
        (newGuid) => {
            if (!newGuid) return;
            setIsPublished(true);
            setGuid(newGuid);
            toast.success(_t.crud.itinerary.publishSuccess());
        },
        [setIsPublished, setIsLoadingPublish, setGuid]
    );

    return {
        isPublished,
        isLoadingPublish,
        publishedLink,
        publish,
        unpublish,
        onPublish,
        onUnPublish,
        onUpdateGuid,
        setIsLoadingPublish
    };
}
